<template>
  <div>
    <header-applis titre="Personnaliser l’offre à votre profil" sous-titre="Les formations qui me correspondent sont celles qui se déroulent" index-progression-courante="3"/>
    <div class="wrapper__content">
      <div v-for="(valeur, index) in valeursPossibles" :key="index" class="checkbox-wrapper">
        <input type="checkbox" :id="'choix_' + index" :value="valeur" v-model="deroulementsFormations" name="statut">
        <label :for="'choix_' + index">{{ valeur }}</label>
      </div>
    </div>
    <footer-applis ecran-precedent="maniereapprendre" :ecran-suivant="ecranSuivant()" label-suivant="Je confirme et je passe à la suite"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'preferencesformations',
  components: {
    FooterApplis,
    HeaderApplis
  },
  data() {
    return {
      deroulementsFormations: [],
      valeursPossibles: [
        'Uniquement en présentiel',
        'Uniquement à distance',
        'En formats alternés université / entreprise',
        'En présentiel et à distance',
        'Les soirs et les WE'
      ]
    }
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    }
  },
  methods: {
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     */
    ecranSuivant() {
      if (!this.deroulementsFormations || this.deroulementsFormations.length === 0) {
        return '';
      }
      this.$store.commit('setDeroulementsFormations', this.deroulementsFormations);
      return 'preferencesengagementformation';
    }
  },
  created() {
    this.deroulementsFormations = this.informationsParcours.deroulementsFormations;
  }
}
</script>
